var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Caption from "../Caption";
import { Col, Row } from "../grid";
import { KeyboardEvents } from "../../enums";
import React from 'react';
import { layout, space } from 'styled-system';
import { css, styled } from "../../utils";
import { Label, InputHintError, OptionalTag } from './Addons/';
import Radio from './Radio';
var Container = styled.div(function (_a) {
    var space = _a.theme.space;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    .InputHintError,\n    .groupLabel {\n      margin-left: ", ";\n    }\n\n    .groupLabel {\n      display: inline-block;\n    }\n  "], ["\n    .InputHintError,\n    .groupLabel {\n      margin-left: ", ";\n    }\n\n    .groupLabel {\n      display: inline-block;\n    }\n  "])), space.large);
}, layout, space);
var StyledCol = styled(Col)(function (_a) {
    var singleColStyle = _a.singleColStyle;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), singleColStyle);
});
var RadioGroup = function (_a) {
    var name = _a.name, currentValue = _a.value, values = _a.values, label = _a.label, layout = _a.layout, error = _a.error, hint = _a.hint, singleColStyle = _a.singleColStyle, optional = _a.optional, className = _a.className, props = __rest(_a, ["name", "value", "values", "label", "layout", "error", "hint", "singleColStyle", "optional", "className"]);
    var handleKeyboardNavigation = function (e, idx) {
        if (e.key === KeyboardEvents.space) {
            e.preventDefault();
            var radio = document.getElementById("radio-".concat(name, "-").concat(values[idx].value));
            radio.click();
        }
        if (e.key === KeyboardEvents.arrowDown || e.key === KeyboardEvents.arrowRight) {
            var newIndex = idx >= values.length - 1 ? idx : idx + 1;
            e.preventDefault();
            var container = document.getElementById("radio-".concat(name, "-").concat(values[newIndex].value, "-container"));
            var radio = document.getElementById("radio-".concat(name, "-").concat(values[newIndex].value));
            container.focus();
            radio.click();
        }
        if (e.key === KeyboardEvents.arrowUp || e.key === KeyboardEvents.arrowLeft) {
            var newIndex = idx <= 0 ? idx : idx - 1;
            e.preventDefault();
            var container = document.getElementById("radio-".concat(name, "-").concat(values[newIndex].value, "-container"));
            var radio = document.getElementById("radio-".concat(name, "-").concat(values[newIndex].value));
            container.focus();
            radio.click();
        }
    };
    return (React.createElement(Container, __assign({ "data-component": "RadioGroup", width: 1, className: className }, props),
        React.createElement(Label, { className: "groupLabel" },
            label,
            optional && React.createElement(OptionalTag, null)),
        React.createElement(Row, { flexDirection: "row", flexWrap: "wrap" }, values.map(function (_a, idx) {
            var hint = _a.hint, item = __rest(_a, ["hint"]);
            return (React.createElement(StyledCol, { key: item.value, width: layout === 'horizontal' ? 1 / 2 : 1, p: 1, display: "flex", singleColStyle: singleColStyle },
                React.createElement(Radio, __assign({ onKeyDown: function (e) { return handleKeyboardNavigation(e, idx); }, tabIndex: idx === 0 ? 0 : -1, key: "radio-".concat(name, "-").concat(item.value), name: name, error: error, checked: item.value === currentValue }, props, item)),
                hint && React.createElement(Caption, null, hint)));
        })),
        React.createElement(InputHintError, { error: error, hint: hint, validation: true })));
};
RadioGroup.defaultProps = {
    layout: 'horizontal',
};
export default RadioGroup;
var templateObject_1, templateObject_2;
//# sourceMappingURL=RadioGroup.js.map